import {IColorChangeable} from '../../Interfaces';

declare let THREE: any;

export class Radius extends (THREE.Line as { new(geometry, material): any; }) implements IColorChangeable {

  static readonly Name = 'radius';

  constructor() {
    const geometry = new THREE.Geometry();
    geometry.vertices.push(
      new THREE.Vector3(0, 0, 0),
      new THREE.Vector3(1, 0, 0)
    );
    const material = new THREE.LineBasicMaterial({
      color: 0x000000
    });
    super(geometry, material);
    this.name = Radius.Name;
  }

  update(radius: number) {
    this.scale.set(radius, 1, 1);
  }

  setColor(color): void {
    this.material.color.copy(color);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Circle/Radius.ts